import axios from "axios";

export let axiosClient = axios.create({
  baseURL: "https://fluffy-khakis-fox.cyclic.app/",
  withCredentials: true
});

export let url =
"https://discord.com/api/oauth2/authorize?client_id=1121549553624158258&redirect_uri=https%3A%2F%2Ffluffy-khakis-fox.cyclic.app%2Fuser%2Flogin%3Fredirect%3Dhttps%3A%2F%2Fapply-manger.web.app&response_type=code&scope=identify%20email%20guilds"

export let discordCdn = "https://cdn.discordapp.com/";
export async function getGuilds() {
  return axiosClient.get("/guilds");
}
export async function createQs(id: string, data: string[]) {
  try {
    return axiosClient
      .post(`/guilds/${id}/qs`, { qs: data })
      .then(() => (window.location.href = "/server/" + id));
  } catch (err) {
    window.location.href = "/";
  }
}
export async function updateQ(id: string, q: string, data: string) {
  try {
    return axiosClient
      .put(`/guilds/${id}/qs/${q}`, { q: data })
      .then(() => (window.location.href = "/server/" + id));
  } catch (err) {
    return err;
  }
}
export async function deleteQ(id: string, q: string) {
  try {
    return axiosClient
      .delete(`/guilds/${id}/qs/${q}`)
      .then(() => (window.location.href = "/server/" + id));
  } catch (err) {
    return err;
  }
}
export async function getQs(id: string) {
  return await axiosClient.get(`/guilds/${id}/qs`);
}

export async function createApply(server: string, reply: {}[]): Promise<void> {
  try {
    await axiosClient.post("/apply/"+server, { reply });
  } catch (error) {
    console.log(error)
  }
  finally{
    window.location.href = "/";
  }
}
export async function getApplys(server: string) {
  return await axiosClient.get("/apply/" + server);
}

export function checkAuth(): void {
  try {
    axiosClient.get("/user/auth");
  } catch (error) {
    window.location.href = "/";
  }
}

export function checkAdmin(id: string): void {
  try {
    axiosClient.get("/user/admin/" + id);
  } catch (error) {
    window.location.href = "/";
  }
}

export async function accept(id: string, server: string) {
  return axiosClient.patch(`apply/${server}/${id}`, { type: "accept" });
}

export async function reject(id: string, server: string) {
  return axiosClient.patch(`apply/${server}/${id}`, { type: "reject" });
}

export function updateSettings(id: string, role1: string, role2: string) {
  axiosClient.put("/guilds/" + id + "/settings", {
    role1,
    role2,
  });
}

export function Restart(id: string) {
  return axiosClient.put("/guilds/" + id + "/restart");
}
